import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { RouterLink } from "@angular/router";
import { CustomizerSettingsService } from "src/app/core/services/customizer-settings.service";

@Component({
  selector: "app-alerts",
  standalone: true,
  imports: [MatCardModule, CommonModule, MatIconModule],
  templateUrl: "./alerts.component.html",
  styleUrl: "./alerts.component.scss",
})
export class AlertsComponent {
  showAlert = false;
  showAlert2 = false;
  showAlert3 = false;
  //showAlert4 = false;
  //showAlert5 = false;
  showAlert6 = false;
  showAlert7 = false;
  showAlert8 = false;
  showAlert9 = false;
  showAlert10 = false;
  showAlert11 = false;
  showAlert12 = false;
  showAlert13 = false;
  showAlert14 = false;
  showAlert15 = false;
  showAlert16 = false;
  showAlert17 = false;
  showAlert18 = false;
  @Input() currentLang: 'en' | 'or' = 'or';
  @Input() alertType: "success" | "info" | "warning" | "error" = "info";
  @Input() alertMessage = "This is an alert message.";
  @Input() title = "Dismissing Alerts";
  @Input() showAlert5 = false;
  @Input() showAlert4 = false;
  dismissAlert() {
    this.showAlert = false;
  }
  dismissAlert2() {
    this.showAlert2 = false;
  }
  dismissAlert3() {
    this.showAlert3 = false;
  }
  dismissAlert4() {
    this.showAlert4 = false;
  }
  dismissAlert5() {
    this.showAlert5 = false;
  }
  dismissAlert6() {
    this.showAlert6 = false;
  }
  dismissAlert7() {
    this.showAlert7 = false;
  }
  dismissAlert8() {
    this.showAlert8 = false;
  }
  dismissAlert9() {
    this.showAlert9 = false;
  }
  dismissAlert10() {
    this.showAlert10 = false;
  }
  dismissAlert11() {
    this.showAlert11 = false;
  }
  dismissAlert12() {
    this.showAlert12 = false;
  }
  dismissAlert13() {
    this.showAlert13 = false;
  }
  dismissAlert14() {
    this.showAlert14 = false;
  }
  dismissAlert15() {
    this.showAlert15 = false;
  }
  dismissAlert16() {
    this.showAlert16 = false;
  }
  dismissAlert17() {
    this.showAlert17 = false;
  }
  dismissAlert18() {
    this.showAlert18 = false;
  }

  constructor(public themeService: CustomizerSettingsService) {}
}
